import type { LeaderboardEntry } from "../metrics.ts";

export type LeaderboardProps = { entries: readonly LeaderboardEntry[] };

// Render vào <tbody id="leaderboard-body"> nên trả về <tr>, không có wrapper.
export function Leaderboard({ entries }: LeaderboardProps) {
  if (!entries.length) {
    return (
      <tr>
        <td colSpan={5} className="lb-empty">No data under current filters.</td>
      </tr>
    );
  }

  return (
    <>
      {entries.map((x, i) => (
        // recruiter là key nhóm của leaderboard() nên chắc chắn unique.
        <tr key={x.recruiter}>
          <td className="lb-rank">{i === 0 ? "👑" : i + 1}</td>
          <td>{x.recruiter}</td>
          <td>{x.intake}</td>
          <td><span className="lb-offers">{x.offers}</span></td>
          <td className="lb-rate">{x.successRate}%</td>
        </tr>
      ))}
    </>
  );
}
